@if (bekannt()) {
  @let label = 'pipeKategorie.' + kategorie() + '.label' | translate;
  @let hinweis = 'pipeKategorie.nichtAussagekraeftig' | translate;
  <span
    class="pkp"
    data-testid="pipe-kategorie-pill"
    [class.pkp--compact]="compact()"
    [class.pkp--nicht-aussagekraeftig]="!istAussagekraeftig()"
    [attr.title]="
      istAussagekraeftig()
        ? label + ' – ' + ('pipeKategorie.' + kategorie() + '.text' | translate)
        : label + ' ' + hinweis
    "
  >
    <span class="pkp__punkt" aria-hidden="true"></span>
    <span class="pkp__label">{{ label }}</span>
    @if (!istAussagekraeftig()) {
      <span class="sr-only">{{ ' ' + hinweis }}</span>
    }
  </span>
}
